import {
  CHANGE_LANGUAGE
} from "../actions/types";

import { languageOptions, dictionaryList } from '../../languages/Options';

const BROWSER_LANG_TO_ID = { en: 'eng', es: 'spa' };

// Falls back to languageOptions[0] (English) if the browser reports no
// language, or one we don't have a dictionary for.
function detectInitialLanguage() {
  if (typeof navigator === 'undefined') return languageOptions[0];

  const browserLangs = (navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language || navigator.userLanguage];

  for (let i = 0; i < browserLangs.length; i += 1) {
    const lang = browserLangs[i];
    if (!lang) continue; // eslint-disable-line no-continue
    const primary = lang.toLowerCase().split('-')[0];
    const id = BROWSER_LANG_TO_ID[primary];
    if (id) {
      const match = languageOptions.find((option) => option.id === id);
      if (match) return match;
    }
  }

  return languageOptions[0];
}

const initialLanguage = detectInitialLanguage();

const initialState = {
  language: initialLanguage,
  dictionary: dictionaryList[initialLanguage.id]
};

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.language,
        dictionary: dictionaryList[action.language.id]
      };
    default:
      return state;
  }
};